<template>
    <span v-if="mostrarIcone">
        <span class="text-warning ml-1">
            <i
                class="fa fa-question-circle fa-lg icon-button"
                title="Justificativa do Desconto"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">Justificativa do Desconto</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <b-form-textarea
                            v-model="itemRequisicao.justificativaDesconto"
                            :rows="4"
                            :disabled="true"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
export default {
    props: {
        itemRequisicao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        }
    },

    computed: {
        mostrarIcone() {
            return this.itemRequisicao.justificativaDesconto
        }
    }
}
</script>
